const removeItem = (items, key) => {
  const newItems = { ...items }
  delete newItems[key]

  return newItems
}

const UserItemReducer = (state = { items: {} }, action) => {
  switch (action.type) {
    case 'TOGGLE_ITEM':
      return {
        ...state,
        items: {
          ...state.items,
          [action.item]: !state.items[action.item],
        },
      }
    case 'ADD_ITEM':
      return {
        ...state,
        items: {
          ...state.items,
          [action.item]: false,
        },
      }
    case 'REMOVE_ITEM':
      return {
        ...state,
        items: removeItem(state.items, action.item),
      }
    default:
      return state
  }
}

export default UserItemReducer
